import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { debounce } from '@mui/material/utils';
import { ListItemText } from '@mui/material';

interface ResultType {
  userId: string;
  userDisplayName: string;
}

export default function AutoCompleteAsync({ getAsyncData, InputSize, styleProps, label, existingUserArr, onSelection, placeHolderText="Select option", selectedValues }) {
  const [value, setValue] = React.useState<ResultType[] | []>(selectedValues);
  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState<readonly ResultType[]>([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const fetchData = React.useMemo(
    () =>
      debounce((request: { input: string }, callback: (results?: readonly ResultType[]) => void) => {
        setIsLoading(true);
        getAsyncData(request.input)
          .then((res) => {
            setIsLoading(false);
            callback(res);
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }, 500),
    []
  );

 
  React.useEffect(() => {
    let active = true;
    if (inputValue === '') {
      setOptions(value ? value : []);
      return undefined;
    }

    fetchData({ input: inputValue }, (results?: readonly ResultType[]) => {
      if (active) {
        let newOptions: readonly ResultType[] = [];

        if (value) {
          newOptions = value;
        }

        if (results) {
          newOptions = [...newOptions, ...results];
        }
        setOptions(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [value, inputValue, fetch, existingUserArr]);

  React.useEffect(() => {

  }, [options])
  React.useEffect(() => {
    if (selectedValues.length === 0) {
      setValue([]);
    }
    setValue(selectedValues);
    setOptions(selectedValues);
  }, [selectedValues])

  return (
    <Autocomplete
      id="autocomplete_async"
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.userDisplayName)}
      multiple={true}
      filterOptions={(x) => x}
      options={options}
      autoComplete
      includeInputInList
      filterSelectedOptions
      loading={isLoading}
      noOptionsText="No Result Found"
      value={value}
      onChange={(e, value) => {
        onSelection(value);
        setValue(value)
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => <TextField {...params} label={label} placeholder={placeHolderText} size={InputSize} style={styleProps} fullWidth />}
      renderOption={(props, option) => {
        return (
          <ListItemText
            {...props}
            primary={option.userDisplayName}
            sx={{ flexDirection: 'column', alignItems: 'normal !important' }}
          />
        );
      }}
    />
  );
}
